import React from "react";
import { motion } from "framer-motion";

const SEAL_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_orbital-geometry-lab/artifacts/5x3imyr4_TAB%20blue%20background%20gold%20seal.png";

export default function TabSealHeader() {
  return (
    <motion.div
      data-testid="tab-seal-header"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className="seal-header"
    >
      <div className="seal-badge" data-testid="tab-seal-badge">
        <img src={SEAL_URL} alt="The Academic Boardroom Seal" />
      </div>
      <span className="seal-kicker">The Academic Boardroom</span>
      <span className="seal-sep">/</span>
      <h1 className="seal-title">The Earth's Shadow</h1>
      <span className="seal-datum">2026 Deep Eclipse</span>
    </motion.div>
  );
}
